import { forwardRef } from 'react';
import classNames from 'classnames';
import { capitalize } from './util';
// eslint-disable-next-line css-modules/no-unused-class
import css from './Spinner.module.scss';
const spinnerVariants = [
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'dark',
    'light'
];
const Spinner = forwardRef((props, ref) => {
    const { animation, 'aria-label': ariaLabel, className, size = 'md', variant, ...rest } = props;
    return (<div ref={ref} aria-label={ariaLabel} className={classNames(css.spinner, {
        [css.spinnerBorder]: animation === 'border',
        [css.spinnerGrow]: animation === 'grow',
        [css[`variant${capitalize(variant)}`]]: variant,
        [css.small]: size === 'sm'
    }, className)} {...rest}/>);
});
Spinner.displayName = 'Spinner';
export { Spinner, spinnerVariants };
//# sourceMappingURL=Spinner.jsx.map